<div class="filter-top-bar mt-0" #filterTopBar>
  <div class="filter-wrapper dropdown">
    <div class="d-flex justify-content-start align-items-center me-10">
      <input type="search" class="form-control table-search ps-35" placeholder="Enter your search term" [formControl]="searchFormControl" />
      <span class="position-absolute icon-search ps-10"></span>
    </div>
    <div
      class="filter-tabs-holder"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
      [cdkDropListConnectedTo]="[deleteArea]">
      <div *ngFor="let filter of filters" cdkDrag (cdkDragStarted)="isBeingDragged = true" (cdkDragEnded)="isBeingDragged = false">
        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
        <div class="filter-tab" *ngIf="filter.show">
          <a
            cdkDragHandle
            class="dropdown-toggle d-flex justify-content-center align-items-center"
            role="button"
            id="filter-{{ filter.filterKey }}"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-bs-auto-close="outside"
            [ngClass]="{ active: isFilterActive(filter) }">
            {{ filter.title }}
            <span *ngIf="getPeekForSelectedValues(filter) as peekValue">&nbsp;({{ peekValue | truncate: 4 }})</span>
          </a>

          <form [formGroup]="form">
            <div
              *ngIf="filter.filterKey === 'paymentType'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div
                  tabindex="0"
                  (keyup.enter)="onChangePaymentSelection('PREPAID')"
                  class="d-flex justify-content-start align-items-center gap-10 my-10 cp"
                  (click)="onChangePaymentSelection('PREPAID')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="paymentTypes.includes('PREPAID')" />
                  </div>
                  <span>Prepaid</span>
                </div>
                <div
                  tabindex="0"
                  (keyup.enter)="onChangePaymentSelection('POSTPAID')"
                  class="d-flex justify-content-start align-items-center gap-10 my-10 cp"
                  (click)="onChangePaymentSelection('POSTPAID')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="paymentTypes.includes('POSTPAID')" />
                  </div>
                  <span>Postpaid</span>
                </div>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'createdAt'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="date-filter-drop mx-15">
                <input-search-period
                  type="createdAt"
                  [autoApply]="false"
                  [start]="createdAtStart"
                  [end]="createdAtEnd"
                  (change)="onChangeCreatedAtDate($event)"
                  [placeholder]="'Created date'"></input-search-period>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'statuses'"
              class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div
                  tabindex="0"
                  (keyup.enter)="onChangeStatus(status)"
                  *ngFor="let status of invoiceStatuses"
                  class="role-item d-flex justify-content-start align-items-center gap-10 my-10 cp"
                  (click)="onChangeStatus(status)">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="status.isChecked" />
                  </div>
                  <i [ngClass]="status.icon"></i>
                  <span>{{ status.label }}</span>
                </div>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'minimumAmount'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input
                  type="text"
                  formControlName="minimumAmount"
                  class="form-control input mb-0_8"
                  placeholder="Minimum Amount"
                  (keydown.enter)="onSubmitClick(); $event.preventDefault()" />
                <input-errors [control]="form.controls.minimumAmount" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'packageNames'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input
                  type="text"
                  formControlName="packageNames"
                  class="form-control input mb-0_8 wider-input"
                  placeholder="Package names separated by comma"
                  (keydown.enter)="onSubmitClick(); $event.preventDefault()" />
                <input-errors [control]="form.controls.packageNames" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'companyNames'"
              class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input
                  type="text"
                  formControlName="companyNames"
                  class="form-control input mb-0_8 wider-input"
                  placeholder="Company names separated by comma"
                  (keydown.enter)="onSubmitClick(); $event.preventDefault()" />
                <input-errors [control]="form.controls.companyNames" [service]="validationService"></input-errors>
              </div>
              <hr />
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick()">Submit</button>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'userIds'"
              class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="user-filter-drop">
                <app-users-select
                  [multiple]="true"
                  [source]="'invoiceUserIds'"
                  (clear)="onClear($event)"
                  (selectUser)="onSelectUser($event)"
                  (unSelectUser)="onUnSelectUser($event)"></app-users-select>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'convertedByUserIds'"
              class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="user-filter-drop">
                <app-users-select
                  [multiple]="true"
                  [source]="'invoiceConvertedByUserIds'"
                  (clear)="onClear($event)"
                  (selectUser)="onSelectConvertedByUser($event)"
                  (unSelectUser)="onUnSelectConvertedByUser($event)"></app-users-select>
              </div>
            </div>

            <div
              *ngIf="filter.filterKey === 'createdByUserIds'"
              class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="user-filter-drop">
                <app-users-select
                  [multiple]="true"
                  [source]="'invoiceCreatedByUserIds'"
                  (clear)="onClear($event)"
                  (selectUser)="onSelectCreatedByUser($event)"
                  (unSelectUser)="onUnSelectCreatedByUser($event)"></app-users-select>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="filter-add-btn" *ngIf="shouldAddFilterBeShown()">
      <a role="button" id="add-filter-link" data-bs-toggle="dropdown" aria-expanded="false"><span class="icon-add"></span> Add Filter</a>
      <ul class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="add-filter-link">
        <ng-container *ngFor="let filter of filters">
          <li
            *ngIf="!filter.show"
            class="dropdown-item filter-item px-15 py-10 cp"
            tabindex="0"
            (keydown.enter)="onAdditionalFilterClick(filter)"
            (click)="onAdditionalFilterClick(filter)">
            <a>{{ filter.title }}</a>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="v-line"></div>

    <div cdkDropList #deleteArea="cdkDropList" (cdkDropListDropped)="deleteItem($event)">
      <div
        tabindex="0"
        (keydown.enter)="onClearAllFilter()"
        class="delete-area d-flex justify-content-center align-items-center"
        (click)="onClearAllFilter()"
        [ngClass]="{ 'drag-active': isBeingDragged }">
        <span class="far fa-trash-alt"></span>
        {{ isBeingDragged ? 'Remove Filter' : 'Clear Filters' }}
      </div>
    </div>
  </div>
</div>
